
// useMediaQuery.js
//
// Subscribes to a CSS media query via matchMedia + useSyncExternalStore,
// so a component only re-renders when the query's boolean result actually
// flips — not on every intermediate resize/pointer event like a manually
// tracked `width` value would.
//
// Usage:
//   const isNarrow = useMediaQuery('(max-width: 767px)');
//   const isCoarsePointer = useMediaQuery('(pointer: coarse)');

import { useSyncExternalStore } from 'react';

export function useMediaQuery(query) {
    return useSyncExternalStore(
        (onChange) => {
            const mql = window.matchMedia(query);
            mql.addEventListener('change', onChange);
            return () => mql.removeEventListener('change', onChange);
        },
        () => window.matchMedia(query).matches,
        () => false // SSR / initial snapshot — this app renders client-only
    );
}

export default useMediaQuery;
